import React, { FormEvent, FunctionComponent, useEffect, useState } from 'react'
import { useDispatch } from 'react-redux'
import useConnectRequest from '../../hooks/useConnectRequest'
import { requestActions } from '../../redux/requests'
import { FETCH_DOCUMENT } from '../../redux/requests/products/product.actions'
import * as S from './styled'
import { useParams } from 'react-router-dom'
import { BeatLoader } from 'react-spinners'
import moment from 'moment'
import { useHistory } from 'react-router'
import { getAuth } from 'firebase/auth'
import { productKeyMap } from '../CreateDocument/ProductKeyMaps'
import { Icon } from '../../components/atoms/Icons/Icon'

type BaseDocument = {
  [key: string]: unknown
}
type OwnProps = {}

type Props = OwnProps

export const ViewDocument: FunctionComponent<Props> = () => {
  const history = useHistory()
  const dispatch = useDispatch()
  const { docId, product } = useParams<{ docId: string; product: string }>()
  const [updatedDocument, setUpdatedDocument] = useState<BaseDocument>({})
  const { data: document, loading } = useConnectRequest(FETCH_DOCUMENT, { multiple: false })
  const auth = getAuth()
  const user = auth.currentUser
  const keyMap = productKeyMap[product]
  useEffect(() => {
    if (!document) {
      dispatch(requestActions.products.fetchDocument(user!.uid, docId, product))
    }
  }, [document])
  function submitHandler(event: FormEvent<HTMLFormElement>): void {
    event.preventDefault()
    updatedDocument.id = document.id
    dispatch(requestActions.products.updateDocument(updatedDocument, product!, user!.uid))
    history.push('/documents')
  }
  return (
    <S.Container>
      <h1>{`${product[0].toUpperCase()}${product.substring(1)}`}</h1>

      {document && (
        <form onSubmit={submitHandler}>
          <>
            {keyMap &&
              keyMap.map((key, i) => {
                return (
                  <S.Div key={i}>
                    {
                      <S.Icon>
                        <Icon iconName={key.icon} />
                      </S.Icon>
                    }
                    <label>{key.displayKey.language.sv}</label>
                    <input
                      defaultValue={document[key.dataKey]}
                      max={key === 'settlementDate' ? moment().format('YYYY-MM-DD') : ''}
                      onChange={e => {
                        setUpdatedDocument({ ...updatedDocument, [key.dataKey]: e.target.value })
                      }}
                    ></input>
                  </S.Div>
                )
              })}
          </>
          <S.Button type="submit">Spara</S.Button>
        </form>
      )}
    </S.Container>
  )
}
